module.exports = __webpack_public_path__ + "img/close-btn.83adca67.svg";